<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <p class="text-black">
          Calendário
        </p>
      </v-col>
    </v-row>
    <v-card rounded="sm">
      <Calendar />
    </v-card>
  </v-container>
</template>
<script>
import Calendar from "./components/Calendar";

export default {
  components:{
    Calendar,
  },
}
</script>
